import React, { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {TextInput, Button, Text, Card, Flex, Title} from '@mantine/core';
import {BackendUrl} from "../../util/config";

export const RequestPasswordReset: React.FC = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setError('');
        setMessage('');

        try {
            const response = await axios.post(BackendUrl + '/auth/forgot-password', { email });
            setMessage(response.data.message);
        } catch (err: any) {
            setError(err.response?.data?.error || 'Something went wrong');
        }
    };

    return (
        <Flex justify={"center"} align={"center"} h={"100vh"} >
            <Flex align={"flex-start"} direction={"column"}>
                <Title order={2} mb="md">
                    Passwort Zurücksetzung Anfragen
                </Title>

                <Card w={400} p="md">
                    <form onSubmit={handleSubmit}>
                        {error && <Text color="red" mb="sm">{error}</Text>}
                        {message && <Text color="green" mb="sm">{message}</Text>}

                        <TextInput
                            label="E-Mail"
                            required
                            mb="sm"
                            value={email}
                            onChange={(e) => setEmail(e.currentTarget.value)}
                        />
                        <Flex justify={"flex-end"}>
                            <Button type="submit" variant={"filled"}>Zurücksetzen</Button>
                        </Flex>
                    </form>

                </Card>
                <Flex  align={"center"} direction={"row"} mt={"15px"} gap={"5px"}>
                    <Text>Zurück zur</Text>
                    <Button p={"0px"} variant="transparent" onClick={() => navigate('/login')}>
                        Anmeldung
                    </Button>
                </Flex>
            </Flex>

        </Flex>

    );
};